import { FunctionComponent, ReactNode } from "react";

import { AppPermissions, Permission, SecurityArea } from "../../auth";
import { UnauthorizedPage } from "../../pages/UnauthorizedPage";

import { LoadingContent } from "./LoadingContent";

export interface RouteGuardProps {
    appPermissions: AppPermissions;
    securityArea?: SecurityArea;
    hasAny?: Permission[];
    render: ReactNode;
}

export const RouteGuard: FunctionComponent<RouteGuardProps> = ({ appPermissions, securityArea, hasAny, render }) => {
    if (import.meta.env.VITE_BYPASS_AUTH === "true" || import.meta.env.VITE_MOCK_ENTIRE_BACKEND === "true") {
        return <>{render}</>;
    }

    if (appPermissions.loading) {
        return <LoadingContent />;
    } else if (hasAny && appPermissions.hasAny(...hasAny)) {
        return render;
    } else if (securityArea && appPermissions.showArea(securityArea)) {
        return render;
    } else {
        return <UnauthorizedPage />;
    }
};
